// removed by extract-text-webpack-plugin
module.exports = {"root":"TemplateConfiguration__root___3JTF8","editor":"TemplateConfiguration__editor___3gxYT"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateConfiguration/TemplateConfiguration.scss
// module id = 1036
// module chunks = 0